// SPDX-License-Identifier: AGPL-3.0-or-later
import { addDays, daysBetween, daysInMonth, isoDate, monthOf, weekday, yearOf } from "./dates.js";
/**
 * The period containing `date`. Weeks start on Sunday, matching the
 * calendar grid.
 */
export function periodRange(period, date) {
    const y = yearOf(date);
    const m = monthOf(date);
    let start;
    let end;
    switch (period) {
        case "day":
            start = end = date;
            break;
        case "week":
            start = addDays(date, -weekday(date));
            end = addDays(start, 6);
            break;
        case "month":
            start = isoDate(y, m, 1);
            end = isoDate(y, m, daysInMonth(y, m));
            break;
        case "year":
            start = isoDate(y, 1, 1);
            end = isoDate(y, 12, 31);
            break;
    }
    return { period, start, end, days: daysBetween(start, end) + 1 };
}
/**
 * Converts a monthly budget amount to the equivalent for another period.
 * The plan is set monthly; every other period is derived, never typed.
 */
export function budgetForPeriod(monthly, range) {
    switch (range.period) {
        case "month":
            return monthly;
        case "year":
            return monthly * 12;
        case "week":
            return Math.round((monthly * 12 * 7) / 365);
        case "day":
            return Math.round((monthly * 12) / 365);
    }
}
//# sourceMappingURL=periods.js.map